
//Libraries
import { defineComponent, onMounted, ref } from "vue";

//Types
import { TabOptionsConfig } from "@/shared/types/config/tab-options-config";

//Config
import { tabs } from "./config/tabs";

//Components
import NavBar from "../../shared/components/Nav.vue";
import TabBar from "../../shared/components/TabOptions.vue";
import UserStatus from "./UserStatus.vue";
import GamesContent from "./GamesContent.vue";

export default defineComponent({
  name: "ShopModule",
  components: {
    NavBar,
    TabBar,
    UserStatus,
    GamesContent,
  },
  setup() {
    //Data

    const tabsOptions: TabOptionsConfig = tabs;

    const isLoading = ref<boolean>(true);

    const currentTab = ref<string>(tabs.currentOption.name);

    //Methods

    const getData = () => {
      setTimeout(() => {
        isLoading.value = false;
      }, 600);
    };

    const setTab = (value: string) => {
      currentTab.value = value;
    };

    //Lifecycle Hooks

    window.scrollTo(0, 0);

    onMounted(() => {
      getData();
    });

    return {
      //Data
      isLoading,
      tabsOptions,
      //Methods
      setTab,
    };
  },
});
